<ng-container *transloco="let convert;">
  <div class="advanced_search_model">
    <div class="advanced_search_model__arrow"></div>
    <div class="form-group advanced_search_model--search">
      <label for="advanced_search_model_search">{{convert('sellModule.manageInventory.advancedSearch.advancedSearchModal.labelSearch')}}</label>
      <div class="control-wrapper">
        <input name="search" id="advanced_search_model_search" class="form-control" (input)="onInput($event)" maxlength="30" />
      </div>
    </div>

    <div class="advanced_search_model--accordion">

      <accordion class="ui-accordion" style="border-style: none;">
        @for (item of formattedModelOptions | keyvalue; track item) {
          <accordion-group
            [heading]="item.key + (selectedModelCount[item.key] ? ': ' + selectedModelCount[item.key] : '')"
            [isOpen]="false"
            >
            <div class="form-group">
              <div class="control-wrapper">
                @for (model of formattedModelOptions[item.key]; track model) {
                  <div
                    class="custom-control custom-checkbox advanced_search_class-checkbox mb-3"
                    >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      [id]="model.vehicleModel"
                      [checked]="checked(model.vehicleModel)"
                      (change)="selectOption(model)"
                      />
                    <label class="custom-control-label" [for]="model.vehicleModel">{{ model.vehicleModel }}</label>
                  </div>
                }
              </div>
            </div>
          </accordion-group>
        }
      </accordion>
    </div>

    <div class="advanced_search_model--action_btn">
      <button
        class="btn btn-secondary advanced_search_model--action_btn__close"
        [attr.aria-label]="convert('common.btnClose')"
        type="button"
        (click)="close()"
        >
        {{convert('common.btnClose')}}
      </button>
    </div>
  </div>
</ng-container>
